import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ISearchAzureReservationOrders,
  IAzureReservationOrders,
} from '../../../services/azure/azureReservationOrders/azureReservationOrders.model';
import azureReservationOrdersService from '../../../services/azure/azureReservationOrders/azureReservationOrders.service';

// Asynchronous thunk action

export const searchAzureReservationOrders = createAsyncThunk(
  'searchAzureReservationOrders',
  async (searchParam?: ISearchAzureReservationOrders) => {
    const response = await azureReservationOrdersService
      .searchAzureReservationOrders(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getAzureReservationOrdersById = createAsyncThunk(
  'getAzureReservationOrdersById',
  async (id: number) => {
    const response = await azureReservationOrdersService.getAzureReservationOrdersById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveAzureReservationOrders = createAsyncThunk(
  'saveAzureReservationOrders',
  async (data: IAzureReservationOrders) => {
    const response = await azureReservationOrdersService.saveAzureReservationOrders(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteAzureReservationOrders = createAsyncThunk(
  'deleteAzureReservationOrders',
  async (id: number) => {
    const response = await azureReservationOrdersService.deleteAzureReservationOrders(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
